import { useUpgradeEdition } from '../hooks/useUpgradeEdition.tsx';
import { useCrossFlowEditionParityData } from '../hooks/useCrossFlowEditionParityData.tsx';

type UseCrossFlowEditionParityProps = {
	sourceProduct: string;
	targetProduct: string;
};

export const useCrossFlowEditionParity = ({
	sourceProduct,
	targetProduct,
}: UseCrossFlowEditionParityProps) => {
	const {
		isLoading,
		offeringId,
		targetEdition,
		entitlementDetails,
		defaultOffering,
		transactionAccountId,
		currentTargetEdition,
		shouldUpgrade,
	} = useCrossFlowEditionParityData({
		sourceProduct,
		targetProduct,
	});

	const { upgradeCCPEntitlement, entitlementUpgrading } = useUpgradeEdition({
		shouldUpgrade: !isLoading && shouldUpgrade,
		entitlementDetails,
		defaultOffering,
		targetOfferingId: offeringId,
		targetEdition,
		transactionAccountId,
		analyticsAttributes: {
			offeringId,
			targetEdition,
			hasEntitlementDetails: !!entitlementDetails,
			hasDefaultOffering: !!defaultOffering,
			entitlementId: entitlementDetails?.entitlementId || '',
			entitlementVersion: entitlementDetails?.version || '',
			transactionAccountId,
			currentTargetEdition,
			sourceProduct,
			targetProduct,
		},
	});

	return {
		loadingUpgradeData: isLoading,
		upgradeCCPEntitlement,
		entitlementUpgrading,
		targetEdition,
	};
};
